<div class="main-content w-100">
  <div class="container-fluid">
    <div class="row w-100">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header card/-header-primary card-header-icon">
            <div class="card-icon">
                <i class="material-icons">perm_identity </i>
            </div>
            <div *ngIf="user.role == 'customer'" class="form-row d-flex align-items-center responsive-container">
              <h4 class="card-title font-weight-bold responsive-text">   <span routerLink="/customers" class="font-weight-bold pointer" >Customers /</span><span routerLink="/pages/company/{{user.companyLinked.id}}" class="font-weight-bold pointer" >{{ user.companyLinked.name }}/</span><span class="font-weight-bold" style="color:#9c27b0;">{{ user.name }} {{ user.surname }}</span> </h4> 
              
            </div>
            <div *ngIf="user.role == 'VENDOR'" class="form-row d-flex align-items-center responsive-container">
             <!--  <h4 class="card-title font-weight-bold responsive-text"> Vendor's Info /<span class="font-weight-bold" style="color:#9c27b0; margin-left: 10px;">{{ user.name }} {{ user.surname }}</span> </h4>  -->
             <h4 class="card-title font-weight-bold responsive-text">  <span routerLink="/vendors" class="font-weight-bold pointer" >Vendor's /</span> <span routerLink="/pages/company/{{user.companyLinked.id}}" class="font-weight-bold pointer" >{{ user.companyLinked.name }}/</span><span class="font-weight-bold" style="color:#9c27b0;">{{ user.name }} {{ user.surname }}</span> </h4> 
            </div>
            <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row d-flex align-items-center responsive-container">
<!--               <h4 class="card-title font-weight-bold responsive-text"> Representatives /<span class="font-weight-bold" style="color:#9c27b0; margin-left: 10px;">{{ user.name }} {{ user.surname }}</span> </h4>  -->
              <h4 class="card-title font-weight-bold responsive-text">   <span routerLink="/tables/listpersonal" class="font-weight-bold pointer" >Representatives /</span><span routerLink="/pages/company/{{user.companyLinked.id}}" class="font-weight-bold pointer" >{{ user.companyLinked.name }}/</span><span class="font-weight-bold" style="color:#9c27b0;">{{ user.name }} {{ user.surname }}</span> </h4> 
            </div>
        </div>
        <div *ngIf="user.role == 'VENDOR'" class="">
          <div class="d-flex flex-column flex-lg-row justify-content-between mt-3">
            <div  class="mr-2 ml-3  mr-lg-0 ml-lg-4 mb-lg-0">
              <app-button-select 
                [outline]="true"
                [icon]="'circle'"
                [optionsIcons]="listStatus" 
                [(selected)]="optionSelectMenuTrigger"
                (selectedChange)="menuTriggerToShow($event)"
                [label]="'Status'"
                [widthPx]="738"
                [specialWidth]="772">
              </app-button-select>
            </div>
            <div class="d-flex flex-column flex-lg-row justify-content-lg-end ml-2">
              <button class="gts-btn-primary-outline font-weight-bold mt-2 mb-2 mr-2 ml-2 mb-lg-0 ml-lg-0 mr-lg-0 mt-lg-0" 
                      (click)="showDetails()" 
                      *ngIf="permissionStatus">
                Manage Permissions
              </button>
              
              <button class="gts-btn-primary-outline font-weight-bold mb-2 mr-2 ml-2 mb-2 mb-lg-0 ml-lg-2 mr-lg-0" 
                      (click)="openModalResetMFA()" 
                      *ngIf="user.role != 'customer'">
                Reset MFA
              </button>
              <button class="gts-btn-primary-outline font-weight-bold mb-2 mr-2 ml-2 mb-2 mb-lg-0 ml-lg-2 mr-lg-0" 
                      (click)="openDelegate()" 
                      *ngIf="user.role != 'VENDOR' && user.role != 'customer'">
                Delegate Clients
              </button>
              <button class="gts-btn-primary-outline font-weight-bold mb-2 mr-2 ml-2 ml-lg-2" 
                      (click)="openChangePasswordDialog()"  
                      *ngIf="user.role != 'customer'">
                Change Password
              </button>
              <button *ngIf="user.role == 'VENDOR'||user.role == 'customer'" 
                      class="gts-btn-primary font-weight-bold mb-2 mr-2 ml-2 mr-lg-2 ml-lg-0" 
                      (click)="OpenContactH()">
                Contact History
              </button>
             <!-- 
              <button 
                    class="gts-btn-primary font-weight-bold mb-2 mr-2 ml-2 mr-lg-2 ml-lg-0"
                    *ngIf="permissionStatus"
                    (click)="changeStateVendor(true)" 
                  >
               {{vendorStatus ? 'Enable Inventory': 'Disable Inventory'}}
              </button>
            -->              
            </div>
          </div>
        </div>
        
        <div *ngIf="user.role != 'VENDOR'" class="">
          <div class="d-flex flex-column flex-lg-row justify-content-between mt-3">
            <div  class="mr-2 ml-3  mr-lg-0 ml-lg-4 mb-lg-0">
              <app-button-select *ngIf="user.role == 'customer'" 
                [outline]="true"
                [icon]="'circle'"
                [optionsIcons]="listStatus" 
                [(selected)]="optionSelectMenuTrigger"
                (selectedChange)="Customertrigger($event)"
                [label]="'Status'"
                [widthPx]="738"
                [specialWidth]="772">
              </app-button-select>
            </div>
          <div class="d-flex flex-column flex-lg-row justify-content-lg-end">
            <button class="gts-btn-primary-outline font-weight-bold mt-2 mb-2 mr-2 ml-2 mb-lg-0 ml-lg-0 mr-lg-0 mt-lg-0" (click)="openModalResetMFA()" *ngIf="user.role != 'customer'" >Reset MFA</button>
            <button class="gts-btn-primary-outline font-weight-bold mb-2 mr-2 ml-2 mb-2 mb-lg-0 ml-lg-2 mr-lg-0"   (click)="openDelegate()" *ngIf="user.role != 'VENDOR' && user.role != 'customer'">Delegate Clients</button>
            <button class="gts-btn-primary-outline font-weight-bold mb-2 mr-2 ml-2 ml-lg-2 " (click)="openChangePasswordDialog()"  *ngIf="user.role != 'customer'">Change Password</button>
            <button *ngIf="user.role == 'customer'" class="gts-btn-primary font-weight-boldmb-2 mt-2 mr-2 ml-2 mr-lg-2 ml-lg-0 mt-lg-0" (click)="OpenContactH()" >Contact History</button>
          </div>
        </div>
        </div>
        <hr>
        <div class="d-flex justify-content-end">
        <mat-slide-toggle (change)="toggleForm()">Edit Rep</mat-slide-toggle>
      </div>
     
     
      <div *ngIf="user.role != 'customer'" class="card-body">
        
          <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
            <div class="col-lg-12 d-flex align-items-center">
              <mat-form-field class="small-form-field flex-grow-1 mb-0">
                <mat-label>Purchasing Rep</mat-label>
                <mat-select [(ngModel)]="selectedRep"  [disabled]="isSelectDisabled">
                  <mat-option *ngFor="let rep of reps" [value]="rep">
                    {{ rep.name }} {{ rep.surname }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button *ngIf="!isEditing" (click)="startEditing()" class="gts-btn-primary ml-2 mb-4" matRipple>
                <span class="gts-btn-icon-left">edit</span>
              </button>
            
              <!-- Botones de guardar y cancelar -->
              <div *ngIf="isEditing" class="d-flex justify-content-between">
                <button (click)="cancelEditing()" class="gts-btn-primary-outline ml-2 mb-4" matRipple>
                  <ng-container *ngIf="!isMobile">
                    <span class="gts-btn-text">Cancel</span>
                  </ng-container>
                  <ng-container *ngIf="isMobile">
                    <span class="gts-btn-icon-left">close</span>
                  </ng-container>
                </button>
                <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
                  <ng-container *ngIf="!isMobile">
                    <span class="gts-btn-text">Save</span>
                  </ng-container>
                  <ng-container *ngIf="isMobile">
                    <span class="gts-btn-icon-left">check</span>
                  </ng-container>
                </button>
              </div>
<!--               <div *ngIf="isEditing" class="d-flex justify-content-between">
                <button (click)="cancelEditing()" class="gts-btn-primary-outline  ml-2 mb-4" matRipple>
                  <span class="gts-btn-text">Cancel</span>
                </button>
                <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
                  <span class="gts-btn-text">Save</span>
                </button>
              </div> -->
              <!-- <button  class="gts-btn-primary ml-2 mb-4" matRipple (click)="ChangeRepBtton()">
                <span class="gts-btn-icon-left">edit</span>
            </button> -->
            </div>
           <!--  <div class="col-lg-12">
              <mat-form-field class="small-form-field">
                <mat-label>Purchasing Rep</mat-label>
                <input class="text-dark" type="text" matInput [(ngModel)]="this.user.managedByString "  placeholder="{{ user.managedByString }}"  disabled>
           
              </mat-form-field>
              <button mat-stroked-button color="primary">Search</button>
            </div> -->
            <div class="col-lg-12">
                    <mat-form-field>
                <mat-label>Company Name</mat-label>
                <input class="text-dark" type="text" matInput name="company"
                [(ngModel)]="user.companyLinked.name" disabled>
              </mat-form-field>
            </div>
          </div>
          <form action="">
          <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
            <div class="col-lg-4">
              <mat-form-field>
                <mat-label>Department and Permissions</mat-label>
                <mat-select name="profile" #profile="ngModel" [(ngModel)]="user.role" placeholder="Department and Permissions" [disabled]="!isFormEnabled">
                  <mat-option *ngFor="let item of groupsList"
                  value="{{ item.id }}" >
                  {{ item.name | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field>
                <mat-label>Department to keep track of KPIs</mat-label>
                <mat-select  name="deptoToCount" #deptoToCount="ngModel" [(ngModel)]="user.deptoToCount" placeholder="Department to keep track of KPIs" [disabled]="!isFormEnabled">
                  <mat-option *ngFor="let depto of deptos"
                  value="{{ depto.value }}" >
                  {{ depto.viewValue | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="small-form-field">
                <input class="text-dark" type="text" matInput name="iqInitials"
                #iqInitials="ngModel"
                [(ngModel)]="user.iqInitials" [disabled]="!isFormEnabled">
                <mat-label>IQ Initials</mat-label>
              </mat-form-field>
            </div>
        </div>
        <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'"  class="form-row">

            <mat-checkbox  name="enabledriver" style="padding-left: 0px!important; padding-right: 50px!important;"
            #enabledriver="ngModel"
            [(ngModel)]="this.user.enableAsDriver" [disabled]="!isFormEnabled">Enable as a Driver</mat-checkbox>

            <mat-checkbox name="bugadmin" #bugadmin="ngModel" [(ngModel)]="this.user.bugTicketNotify" (change)="bugadmin($event)"  style="padding-left: 0px!important; padding-right: 50px!important;"
           
           [disabled]="!isFormEnabled">Bug Admin</mat-checkbox>

        </div>
        <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Info</h5>
        </div>
        <div class="form-row" *ngIf="user.role == 'VENDOR'" >
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Vendors Info</h5>
        </div>
        <div class="form-row" *ngIf="user.role == 'customer'">
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >User Info</h5>
        </div>
        <div class="" *ngIf="user.role == 'VENDOR'||user.role == 'customer'">
          <div class="form-row">
            <div class="col-lg-4">
              <mat-form-field class="small-form-field">
                <input class="text-dark" type="text" matInput name="name"
                #name="ngModel"
                [(ngModel)]="user.name" [disabled]="!isFormEnabled">
                <mat-label>First Name</mat-label>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="small-form-field">
                <input class="text-dark" type="text" matInput  name="surname"
                #surname="ngModel"
                [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
                <mat-label>Last Name</mat-label>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="small-form-field">
                <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
                [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
                <mat-label>Title</mat-label>
              </mat-form-field>    
                                
                                
            </div>
          </div>
          <div class="form-row">
            <div class="col-lg-6">
              <mat-form-field class="small-form-field">
                <input class="text-dark" type="email" matInput name="email"
                #email="ngModel"
                [(ngModel)]="user.email" [disabled]="!isFormEnabled">
                <mat-label>Email</mat-label>
              </mat-form-field>
            </div>
            <div class="col-lg-6">
          
              <mat-form-field>
                <mat-label>Gender</mat-label>
                <mat-select name="gender"
                #gender="ngModel"
                [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
                  <mat-option *ngFor="let tipo of sexos"
                  [value]="tipo.value" >
                  {{ tipo.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="" *ngIf="user.role != 'VENDOR' && user.role != 'customer'">

       
        <div  class="form-row">
          <div class="col-lg-12">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="company"
            [(ngModel)]="user.companyLinked.name" disabled>
            <mat-label>Company</mat-label>
          </mat-form-field>
        </div>
        </div>
        <div  class="form-row">
          <div class="col-lg-12">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
              [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
              <mat-label>Title</mat-label>
            </mat-form-field>
           
                              
                              
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="name"
              #name="ngModel"
              [(ngModel)]="user.name" [disabled]="!isFormEnabled">
              <mat-label>First Name</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput  name="surname"
              #surname="ngModel"
              [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
              <mat-label>Last Name</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="email" matInput name="email"
              #email="ngModel"
              [(ngModel)]="user.email" [disabled]="!isFormEnabled">
              <mat-label>Email</mat-label>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-4">
          
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select name="gender"
              #gender="ngModel"
              [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
                <mat-option *ngFor="let tipo of sexos"
                [value]="tipo.value" >
                {{ tipo.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <mat-label>Birth Date:</mat-label>
              <input matInput [matDatepicker]="birthPicker"  name="birthDate"
              #birthDate="ngModel"
              [(ngModel)]="user.birthDate" [disabled]="!isFormEnabled">
              <mat-datepicker-toggle matIconSuffix [for]="birthPicker"></mat-datepicker-toggle>
              <mat-datepicker #birthPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <mat-label>Hire Date:</mat-label>
              <input matInput [matDatepicker]="hirePicker" name="starToWorkDate"
              #starToWorkDate="ngModel"
              [(ngModel)]="user.joinToWork" [disabled]="!isFormEnabled">
              <mat-datepicker-toggle matIconSuffix [for]="hirePicker"></mat-datepicker-toggle>
              <mat-datepicker #hirePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
        <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Address Info</h5>
        </div>
        <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Address Info</h5>
        </div>
        <div  *ngIf="user.role == 'VENDOR'||user.role == 'customer'"  class="form-row">
          <div class="col-12">
            <mat-form-field>
              <mat-label>Address</mat-label>
              <mat-select name="userlocation"
              #userlocation="ngModel"
              [(ngModel)]="user.locationId" [disabled]="!isFormEnabled" (selectionChange)="changeLocation()">
                <mat-option [value]="0" >
                  Blank - Client Address
                </mat-option>
                <mat-option [value]="1" >
                  Headquarter's Address
                </mat-option>
                <mat-option *ngFor="let loc of companyLocations"
                [value]="loc.id" >
                {{ loc.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> 

        </div>
        <div class="form-row">
          <div class="col-lg-6">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="address"
              #address="ngModel"
              [(ngModel)]="user.address" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>Address 1</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="address2"
              #address2="ngModel"
              [(ngModel)]="user.address2" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>Address 2</mat-label>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="country"
              #country="ngModel"
              [(ngModel)]="user.country" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>Country</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="colonia"
              #colonia="ngModel"
              [(ngModel)]="user.colonia" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>State</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="city"
              #city="ngModel"
              [(ngModel)]="user.city" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>City</mat-label>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput nname="zipCode"
              #zipCode="ngModel"
              [(ngModel)]="user.zipCode" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>Zip Code</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="phone"
              #phone="ngModel"
              [(ngModel)]="user.phone" [disabled]="!isFormEnabled || user.locationId == 1">
              <mat-label>Work Phone</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="mobilePhone"
              #mobilePhone="ngModel"
              [(ngModel)]="user.mobilePhone"[disabled]="!isFormEnabled">
              <mat-label>Mobile Phone</mat-label>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
          <div class="col-lg-12">
            <mat-form-field>
              <mat-label>Default Warehouse Location</mat-label>
              <mat-select 
              name="location"
              #location="ngModel"
              [(ngModel)]="user.location.id" [disabled]="!isFormEnabled">
                <mat-option  *ngFor="let loc of warehouseList"
                [value]="loc.id" >
                {{ loc.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
          <div class="col-lg-12">
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Settings</h5>
        </div>
        <div *ngIf="user.role == 'customer'" class="col-lg-6">
   <!--        <select
          id="customerType"
          name="customerType"
          #customerType="ngModel"
          [(ngModel)]="user.customerType"
          placeholder="Customer Type"
          class="form-control fctrl"
          required
        >
          <option value="" disabled>
            * Please select a type
          </option>
          <option value="End User">End User</option>
          <option value="Wholesaler">Wholesaler</option>
          <option value="Broker">Broker</option>
          <option value="Reseller">Reseller</option>
        </select> -->
        <mat-form-field>
          <mat-label>Customer Type</mat-label>
          <mat-select 
          id="customerType"
          name="customerType"
          #customerType="ngModel"
          [(ngModel)]="user.customerType" [disabled]="!isFormEnabled">
          <mat-option value="End User" >
            End User
        </mat-option>
        <mat-option value="Wholesaler">Wholesaler
        </mat-option>
        <mat-option value="Broker">Broker
       
        </mat-option>
        <mat-option value="Reseller">Reseller
       
        </mat-option>
        
          </mat-select>
        </mat-form-field>
        </div>
        <div *ngIf="user.role == 'VENDOR'"  class="col-lg-6">
          <mat-form-field>
            <mat-label>Email Frequency</mat-label>
            <mat-select 
            name="emailFrequency"
            #emailFrequency="ngModel"
            [(ngModel)]="user.emailFrequency" [disabled]="!isFormEnabled">
            <mat-option  *ngFor="let frequency of frequencies"
            [value]="frequency.value" >
            {{ frequency.viewValue }}
            </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        </div>
        <div class="form-row">
          <div class="col-12">
          
              <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Comments</h5>
              <app-comments
              [id_phather]="idUser"
              type_chat="CUSTOMER"
              type_notification="CITA_COMMENT"
            ></app-comments>
            </div>
          
        </div>
        <div class="d-flex justify-content-end fixed-button-container">
          <button  matRipple class="gts-btn-primary-outline mt-2 mb-2 mr-2 btn-save" (click)="goBack()"  >
            <span class="gts-btn-text">Cancel</span>
          </button>
          <button  matRipple class="gts-btn-primary mt-2 mb-2 btn-cancel" (click)="onSubmit();"  >
            <span class="gts-btn-text">Save Changes</span>
           </button>

        </div>
        </form>
      </div>
<!-- Customer Show -->
<div class="" *ngIf="!isMobile" >
<div *ngIf="user.role == 'customer'" class="d-flex justify-content-between">

  <div class="card-body w-50">
    
      <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
        <div class="col-lg-12 d-flex align-items-center">
          <mat-form-field class="small-form-field flex-grow-1 mb-0">
            <mat-label>Sales Rep</mat-label>
            <mat-select [(ngModel)]="selectedRep"  [disabled]="isSelectDisabled">
              <mat-option *ngFor="let rep of reps" [value]="rep">
                {{ rep.name }} {{ rep.surname }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button *ngIf="!isEditing" (click)="startEditing()" class="gts-btn-primary ml-2 mb-4" matRipple>
            <span class="gts-btn-icon-left">edit</span>
          </button>
        
          <!-- Botones de guardar y cancelar -->
          <div *ngIf="isEditing" class="d-flex justify-content-between">
            <button (click)="cancelEditing()" class="gts-btn-primary-outline ml-2 mb-4" matRipple>
              <ng-container *ngIf="!isMobile">
                <span class="gts-btn-text">Cancel</span>
              </ng-container>
              <ng-container *ngIf="isMobile">
                <span class="gts-btn-icon-left">close</span>
              </ng-container>
            </button>
            <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
              <ng-container *ngIf="!isMobile">
                <span class="gts-btn-text">Save</span>
              </ng-container>
              <ng-container *ngIf="isMobile">
                <span class="gts-btn-icon-left">check</span>
              </ng-container>
            </button>
          </div>
<!--           <div *ngIf="isEditing" class="d-flex justify-content-between">
            <button (click)="cancelEditing()" class="gts-btn-primary-outline  ml-2 mb-4" matRipple>
              <span class="gts-btn-text">Cancel</span>
            </button>
            <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
              <span class="gts-btn-text">Save</span>
            </button>

          </div> -->
          <!-- <button  class="gts-btn-primary ml-2 mb-4" matRipple >
            <span class="gts-btn-icon-left">edit</span>
          </button> -->
        </div>
       <!--  <div class="col-lg-12">
          <mat-form-field class="small-form-field">
            <mat-label>Purchasing Rep</mat-label>
            <input class="text-dark" type="text" matInput [(ngModel)]="this.user.managedByString "  placeholder="{{ user.managedByString }}"  disabled>
       
          </mat-form-field>
          <button mat-stroked-button color="primary">Search</button>
        </div> -->
        <div class="col-lg-12">
                <mat-form-field>
            <mat-label>Company Name</mat-label>
            <input class="text-dark" type="text" matInput name="company"
            [(ngModel)]="user.companyLinked.name" disabled>
          </mat-form-field>
        </div>
      </div>
      <form action="">
      <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
        <div class="col-lg-6">
          <mat-form-field>
            <mat-label>Department and Permissions</mat-label>
            <mat-select name="profile" #profile="ngModel" [(ngModel)]="user.role" placeholder="Department and Permissions" [disabled]="!isFormEnabled">
              <mat-option *ngFor="let item of groupsList"
              value="{{ item.id }}" >
              {{ item.name | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field>
            <mat-label>Department to keep track of KPIs</mat-label>
            <mat-select  name="deptoToCount" #deptoToCount="ngModel" [(ngModel)]="user.deptoToCount" placeholder="Department to keep track of KPIs" [disabled]="!isFormEnabled">
              <mat-option *ngFor="let depto of deptos"
              value="{{ depto.value }}" >
              {{ depto.viewValue | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
    </div>
    <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'"  class="form-row">

        <mat-checkbox  name="enabledriver" style="padding-left: 0px!important; padding-right: 50px!important;"
        #enabledriver="ngModel"
        [(ngModel)]="this.user.enableAsDriver" [disabled]="!isFormEnabled">Enable as a Driver</mat-checkbox>

        <mat-checkbox name="bugadmin" #bugadmin="ngModel" [(ngModel)]="this.user.bugTicketNotify" (change)="bugadmin($event)"  style="padding-left: 0px!important; padding-right: 50px!important;"
       
       [disabled]="!isFormEnabled">Bug Admin</mat-checkbox>

    </div>
    <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Info</h5>
    </div>
    <div class="form-row" *ngIf="user.role == 'VENDOR'" >
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Vendors Info</h5>
    </div>
    <div class="form-row" *ngIf="user.role == 'customer'">
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >User Info</h5>
    </div>
    <div class="" *ngIf="user.role == 'VENDOR'||user.role == 'customer'">
      <div class="form-row">
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="name"
            #name="ngModel"
            [(ngModel)]="user.name" [disabled]="!isFormEnabled">
            <mat-label>First Name</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput  name="surname"
            #surname="ngModel"
            [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
            <mat-label>Last Name</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
            [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
            <mat-label>Title</mat-label>
          </mat-form-field>    
                            
                            
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-6">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="email" matInput name="email"
            #email="ngModel"
            [(ngModel)]="user.email" [disabled]="!isFormEnabled">
            <mat-label>Email</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
      
          <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select name="gender"
            #gender="ngModel"
            [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
              <mat-option *ngFor="let tipo of sexos"
              [value]="tipo.value" >
              {{ tipo.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="" *ngIf="user.role != 'VENDOR' && user.role != 'customer'">

   
    <div  class="form-row">
      <div class="col-lg-12">
      <mat-form-field class="small-form-field">
        <input class="text-dark" type="text" matInput name="company"
        [(ngModel)]="user.companyLinked.name" disabled>
        <mat-label>Company</mat-label>
      </mat-form-field>
    </div>
    </div>
    <div  class="form-row">
      <div class="col-lg-12">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
          [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
          <mat-label>Title</mat-label>
        </mat-form-field>
       
                          
                          
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="name"
          #name="ngModel"
          [(ngModel)]="user.name" [disabled]="!isFormEnabled">
          <mat-label>First Name</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput  name="surname"
          #surname="ngModel"
          [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
          <mat-label>Last Name</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="email" matInput name="email"
          #email="ngModel"
          [(ngModel)]="user.email" [disabled]="!isFormEnabled">
          <mat-label>Email</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-4">
      
        <mat-form-field>
          <mat-label>Gender</mat-label>
          <mat-select name="gender"
          #gender="ngModel"
          [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
            <mat-option *ngFor="let tipo of sexos"
            [value]="tipo.value" >
            {{ tipo.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <mat-label>Birth Date:</mat-label>
          <input matInput [matDatepicker]="birthPicker"  name="birthDate"
          #birthDate="ngModel"
          [(ngModel)]="user.birthDate" [disabled]="!isFormEnabled">
          <mat-datepicker-toggle matIconSuffix [for]="birthPicker"></mat-datepicker-toggle>
          <mat-datepicker #birthPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <mat-label>Hire Date:</mat-label>
          <input matInput [matDatepicker]="hirePicker" name="starToWorkDate"
          #starToWorkDate="ngModel"
          [(ngModel)]="user.joinToWork" [disabled]="!isFormEnabled">
          <mat-datepicker-toggle matIconSuffix [for]="hirePicker"></mat-datepicker-toggle>
          <mat-datepicker #hirePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
    <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Address Info</h5>
    </div>
    <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Address Info</h5>
    </div>
    <div  *ngIf="user.role == 'VENDOR'||user.role == 'customer'"  class="form-row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Address</mat-label>
          <mat-select name="userlocation"
          #userlocation="ngModel"
          [(ngModel)]="user.locationId" [disabled]="!isFormEnabled" (selectionChange)="changeLocation()">
            <mat-option [value]="0" >
              Blank - Client Address
            </mat-option>
            <mat-option [value]="1" >
              Headquarter's Address
            </mat-option>
            <mat-option *ngFor="let loc of companyLocations"
            [value]="loc.id" >
            {{ loc.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
    <div class="form-row">
      <div class="col-lg-6">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="address"
          #address="ngModel"
          [(ngModel)]="user.address" [disabled]="!isFormEnabled">
          <mat-label>Address 1</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="address2"
          #address2="ngModel"
          [(ngModel)]="user.address2" [disabled]="!isFormEnabled">
          <mat-label>Address 2</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="country"
          #country="ngModel"
          [(ngModel)]="user.country" [disabled]="!isFormEnabled">
          <mat-label>Country</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="colonia"
          #colonia="ngModel"
          [(ngModel)]="user.colonia" [disabled]="!isFormEnabled">
          <mat-label>State</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="city"
          #city="ngModel"
          [(ngModel)]="user.city" [disabled]="!isFormEnabled">
          <mat-label>City</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput nname="zipCode"
          #zipCode="ngModel"
          [(ngModel)]="user.zipCode" [disabled]="!isFormEnabled">
          <mat-label>Zip Code</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="phone"
          #phone="ngModel"
          [(ngModel)]="user.phone" [disabled]="!isFormEnabled">
          <mat-label>Work Phone</mat-label>
        </mat-form-field>
      </div>
      <div class="col-lg-4">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="mobilePhone"
          #mobilePhone="ngModel"
          [(ngModel)]="user.mobilePhone"[disabled]="!isFormEnabled">
          <mat-label>Mobile Phone</mat-label>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
      <div class="col-lg-12">
        <mat-form-field>
          <mat-label>Default Warehouse Location</mat-label>
          <mat-select 
          name="location"
          #location="ngModel"
          [(ngModel)]="user.location.id" [disabled]="!isFormEnabled">
            <mat-option  *ngFor="let loc of warehouseList"
            [value]="loc.id" >
            {{ loc.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
      <div class="col-lg-12">
      <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Settings</h5>
    </div>
    <div *ngIf="user.role == 'customer'" class="col-lg-6">
<!--        <select
      id="customerType"
      name="customerType"
      #customerType="ngModel"
      [(ngModel)]="user.customerType"
      placeholder="Customer Type"
      class="form-control fctrl"
      required
    >
      <option value="" disabled>
        * Please select a type
      </option>
      <option value="End User">End User</option>
      <option value="Wholesaler">Wholesaler</option>
      <option value="Broker">Broker</option>
      <option value="Reseller">Reseller</option>
    </select> -->
    <mat-form-field>
      <mat-label>Customer Type</mat-label>
      <mat-select 
      id="customerType"
      name="customerType"
      #customerType="ngModel"
      [(ngModel)]="user.customerType" [disabled]="!isFormEnabled">
      <mat-option value="End User" >
        End User
    </mat-option>
    <mat-option value="Wholesaler">Wholesaler
    </mat-option>
    <mat-option value="Broker">Broker
   
    </mat-option>
    <mat-option value="Reseller">Reseller
   
    </mat-option>
    
      </mat-select>
    </mat-form-field>
    </div>
    <div *ngIf="user.role == 'VENDOR'"  class="col-lg-6">
      <mat-form-field>
        <mat-label>Email Frequency</mat-label>
        <mat-select 
        name="emailFrequency"
        #emailFrequency="ngModel"
        [(ngModel)]="user.emailFrequency" [disabled]="!isFormEnabled">
        <mat-option  *ngFor="let frequency of frequencies"
        [value]="frequency.value" >
        {{ frequency.viewValue }}
        </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    </div>
    <div class="form-row">
      <div class="col-12">
      
          <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Comments</h5>
          <app-comments
          [id_phather]="idUser"
          type_chat="CUSTOMER"
          type_notification="CITA_COMMENT"
        ></app-comments>
        </div>
      
    </div>
    <div class="d-flex justify-content-end fixed-button-container">
      <button  matRipple class="gts-btn-primary-outline mt-2 mb-2 mr-2 btn-save" (click)="goBack()"  >
        <span class="gts-btn-text">Cancel</span>
      </button>
      <button  matRipple class="gts-btn-primary mt-2 mb-2 btn-cancel" (click)="onSubmit();"  >
        <span class="gts-btn-text">Save Changes</span>
       </button>

    </div>
    </form>
  </div>

    <div class="d-flex flex-column align-items-start" style="width: 30%;">
      <div *ngIf="user" class="pt-2">
        <mat-expansion-panel [expanded]="!isMobile" (opened)="isPanelOpen = true" (closed)="isPanelOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <button mat-button><h4 class="font-weight-bold">Rank</h4></button>
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div class="col-sm-4">
<!-- RANK -->
          <!-- <h4 class="font-weight-bold">Rank</h4> -->
        </div>

     
     
        <div class="col-sm-4 col-md-8">
          <h4>Pricing</h4>
        </div>
        <div class="col-lg-12 col-md-6">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstar(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIcon(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Response Time</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarResponse(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconResponse(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Payment on time</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarPayment(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconPayment(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Easy to work with</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarEasy(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconEasy(i)}}
            </mat-icon>
          </button>
        </div>
      </mat-expansion-panel>
      </div>
      <div class="categories-container mt-4 ">
        <mat-expansion-panel [expanded]="!isMobile" (opened)="isPanelOpen = true" (closed)="isPanelOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <button mat-button><h4 class="font-weight-bold">Categories</h4></button>
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div class="col-lg-12">
          <!-- <h4 class="font-weight-bold">Categories</h4> -->
        </div>
        <mat-spinner class="custom-spinner" style="stroke:#9c27b0;" *ngIf="!categories || categories.length === 0"></mat-spinner>
        <div  *ngIf="categories && categories.length > 0" class="row ml-4">
          <div class="col-12" *ngFor="let item of categories">
            <div class="row">
              <mat-checkbox
                [name]="item.name"
                (change)="addCategoire(item, $event)"
                [checked]="isCheked(item)"
                >{{ item.name }}</mat-checkbox
              >
            </div>
            <div *ngIf="isAdded(item.id)">
              <div class="row" *ngIf="item.sub.length > 1">
                &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                <mat-checkbox
                  [name]="item.id"
                  (change)="
                    addCategoire(
                      { id: item.id, father: item.id, name: 'All' },
                      $event
                    )
                  "
                  [checked]="checkedAll(item.id)"
                  >All</mat-checkbox
                >
              </div>
              <div class="row" *ngFor="let i of item.sub">
                &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                <mat-checkbox
                  [name]="i.name"
                  (change)="addCategoire(i, $event)"
                  [checked]="isCheked(i)"
                >
                  {{ i.name }}</mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">

        </div>
      </mat-expansion-panel>
      </div>
    </div>
  
  <!-- rank customer end  -->
</div>
</div>
<!-- MOBILE VIEW -->
<div class="" *ngIf="isMobile" >
  <div *ngIf="user.role == 'customer'" class="">
    <div class="d-flex flex-column align-items-start" style="width: 100%;">
      <div *ngIf="user" class="pt-2 w-100">
        <mat-expansion-panel [expanded]="!isMobile" (opened)="isPanelOpen = true" (closed)="isPanelOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <button mat-button><h4 class="font-weight-bold">Rank</h4></button>
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div class="col-sm-4">
<!-- RANK -->
          <!-- <h4 class="font-weight-bold">Rank</h4> -->
        </div>

     
     
        <div class="col-sm-4">
          <h4>Pricing</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstar(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIcon(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Response Time</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarResponse(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconResponse(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Payment on time</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'"  *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarPayment(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconPayment(i)}}
            </mat-icon>
          </button>
        </div>
        <div class="col-lg-12">
          <h4>Easy to work with</h4>
        </div>
        <div class="col-lg-12">
          <button mat-icon-button [ngClass]="'yellow-button'" *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="clickstarEasy(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
            <mat-icon>
              {{showIconEasy(i)}}
            </mat-icon>
          </button>
        </div>
      </mat-expansion-panel>
      </div>
      <div class="categories-container w-100 mt-4">
        <mat-expansion-panel [expanded]="!isMobile" (opened)="isPanelOpen = true" (closed)="isPanelOpen = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <button mat-button><h4 class="font-weight-bold">Categories</h4></button>
            </mat-panel-title>
          </mat-expansion-panel-header>
        <div class="col-lg-12">
          <!-- <h4 class="font-weight-bold">Categories</h4> -->
        </div>
        <div class="row ml-4">
          <div class="col-12" *ngFor="let item of categories">
            <div class="row">
              <mat-checkbox
                [name]="item.name"
                (change)="addCategoire(item, $event)"
                [checked]="isCheked(item)"
                >{{ item.name }}</mat-checkbox
              >
            </div>
            <div *ngIf="isAdded(item.id)">
              <div class="row" *ngIf="item.sub.length > 1">
                &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                <mat-checkbox
                  [name]="item.id"
                  (change)="
                    addCategoire(
                      { id: item.id, father: item.id, name: 'All' },
                      $event
                    )
                  "
                  [checked]="checkedAll(item.id)"
                  >All</mat-checkbox
                >
              </div>
              <div class="row" *ngFor="let i of item.sub">
                &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                <mat-checkbox
                  [name]="i.name"
                  (change)="addCategoire(i, $event)"
                  [checked]="isCheked(i)"
                >
                  {{ i.name }}</mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">

        </div>
      </mat-expansion-panel>
      </div>
    </div>
    <div class="card-body w-100">
      
        <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
          <div class="col-lg-12 d-flex align-items-center">
            <mat-form-field class="small-form-field flex-grow-1 mb-0">
              <mat-label>Sales Rep</mat-label>
              <mat-select [(ngModel)]="selectedRep"  [disabled]="isSelectDisabled">
                <mat-option *ngFor="let rep of reps" [value]="rep">
                  {{ rep.name }} {{ rep.surname }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button *ngIf="!isEditing" (click)="startEditing()" class="gts-btn-primary ml-2 mb-4" matRipple>
              <span class="gts-btn-icon-left">edit</span>
            </button>
          
            <!-- Botones de guardar y cancelar -->
            <div *ngIf="isEditing" class="d-flex justify-content-between">
              <button (click)="cancelEditing()" class="gts-btn-primary-outline ml-2 mb-4" matRipple>
                <ng-container *ngIf="!isMobile">
                  <span class="gts-btn-text">Cancel</span>
                </ng-container>
                <ng-container *ngIf="isMobile">
                  <span class="gts-btn-icon-left">close</span>
                </ng-container>
              </button>
              <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
                <ng-container *ngIf="!isMobile">
                  <span class="gts-btn-text">Save</span>
                </ng-container>
                <ng-container *ngIf="isMobile">
                  <span class="gts-btn-icon-left">check</span>
                </ng-container>
              </button>
            </div>
  <!--           <div *ngIf="isEditing" class="d-flex justify-content-between">
              <button (click)="cancelEditing()" class="gts-btn-primary-outline  ml-2 mb-4" matRipple>
                <span class="gts-btn-text">Cancel</span>
              </button>
              <button (click)="saveChanges()" class="gts-btn-primary ml-2 mb-4" matRipple>
                <span class="gts-btn-text">Save</span>
              </button>
  
            </div> -->
            <!-- <button  class="gts-btn-primary ml-2 mb-4" matRipple >
              <span class="gts-btn-icon-left">edit</span>
            </button> -->
          </div>
         <!--  <div class="col-lg-12">
            <mat-form-field class="small-form-field">
              <mat-label>Purchasing Rep</mat-label>
              <input class="text-dark" type="text" matInput [(ngModel)]="this.user.managedByString "  placeholder="{{ user.managedByString }}"  disabled>
         
            </mat-form-field>
            <button mat-stroked-button color="primary">Search</button>
          </div> -->
          <div class="col-lg-12">
                  <mat-form-field>
              <mat-label>Company Name</mat-label>
              <input class="text-dark" type="text" matInput name="company"
              [(ngModel)]="user.companyLinked.name" disabled>
            </mat-form-field>
          </div>
        </div>
        <form action="">
        <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
          <div class="col-lg-6">
            <mat-form-field>
              <mat-label>Department and Permissions</mat-label>
              <mat-select name="profile" #profile="ngModel" [(ngModel)]="user.role" placeholder="Department and Permissions" [disabled]="!isFormEnabled">
                <mat-option *ngFor="let item of groupsList"
                value="{{ item.id }}" >
                {{ item.name | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <mat-form-field>
              <mat-label>Department to keep track of KPIs</mat-label>
              <mat-select  name="deptoToCount" #deptoToCount="ngModel" [(ngModel)]="user.deptoToCount" placeholder="Department to keep track of KPIs" [disabled]="!isFormEnabled">
                <mat-option *ngFor="let depto of deptos"
                value="{{ depto.value }}" >
                {{ depto.viewValue | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
      <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'"  class="form-row">
  
          <mat-checkbox  name="enabledriver" style="padding-left: 0px!important; padding-right: 50px!important;"
          #enabledriver="ngModel"
          [(ngModel)]="this.user.enableAsDriver" [disabled]="!isFormEnabled">Enable as a Driver</mat-checkbox>
  
          <mat-checkbox name="bugadmin" #bugadmin="ngModel" [(ngModel)]="this.user.bugTicketNotify" (change)="bugadmin($event)"  style="padding-left: 0px!important; padding-right: 50px!important;"
         
         [disabled]="!isFormEnabled">Bug Admin</mat-checkbox>
  
      </div>
      <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Info</h5>
      </div>
      <div class="form-row" *ngIf="user.role == 'VENDOR'" >
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Vendors Info</h5>
      </div>
      <div class="form-row" *ngIf="user.role == 'customer'">
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >User Info</h5>
      </div>
      <div class="" *ngIf="user.role == 'VENDOR'||user.role == 'customer'">
        <div class="form-row">
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="name"
              #name="ngModel"
              [(ngModel)]="user.name" [disabled]="!isFormEnabled">
              <mat-label>First Name</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput  name="surname"
              #surname="ngModel"
              [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
              <mat-label>Last Name</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
              [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
              <mat-label>Title</mat-label>
            </mat-form-field>    
                              
                              
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-6">
            <mat-form-field class="small-form-field">
              <input class="text-dark" type="email" matInput name="email"
              #email="ngModel"
              [(ngModel)]="user.email" [disabled]="!isFormEnabled">
              <mat-label>Email</mat-label>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
        
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select name="gender"
              #gender="ngModel"
              [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
                <mat-option *ngFor="let tipo of sexos"
                [value]="tipo.value" >
                {{ tipo.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="" *ngIf="user.role != 'VENDOR' && user.role != 'customer'">
  
     
      <div  class="form-row">
        <div class="col-lg-12">
        <mat-form-field class="small-form-field">
          <input class="text-dark" type="text" matInput name="company"
          [(ngModel)]="user.companyLinked.name" disabled>
          <mat-label>Company</mat-label>
        </mat-form-field>
      </div>
      </div>
      <div  class="form-row">
        <div class="col-lg-12">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="ocupation" #ocupation="ngModel"
            [(ngModel)]="user.ocupation" [disabled]="!isFormEnabled">
            <mat-label>Title</mat-label>
          </mat-form-field>
         
                            
                            
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="name"
            #name="ngModel"
            [(ngModel)]="user.name" [disabled]="!isFormEnabled">
            <mat-label>First Name</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput  name="surname"
            #surname="ngModel"
            [(ngModel)]="user.surname" [disabled]="!isFormEnabled">
            <mat-label>Last Name</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="email" matInput name="email"
            #email="ngModel"
            [(ngModel)]="user.email" [disabled]="!isFormEnabled">
            <mat-label>Email</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4">
        
          <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select name="gender"
            #gender="ngModel"
            [(ngModel)]="user.gender" placeholder="Gender" [disabled]="!isFormEnabled">
              <mat-option *ngFor="let tipo of sexos"
              [value]="tipo.value" >
              {{ tipo.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <mat-label>Birth Date:</mat-label>
            <input matInput [matDatepicker]="birthPicker"  name="birthDate"
            #birthDate="ngModel"
            [(ngModel)]="user.birthDate" [disabled]="!isFormEnabled">
            <mat-datepicker-toggle matIconSuffix [for]="birthPicker"></mat-datepicker-toggle>
            <mat-datepicker #birthPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <mat-label>Hire Date:</mat-label>
            <input matInput [matDatepicker]="hirePicker" name="starToWorkDate"
            #starToWorkDate="ngModel"
            [(ngModel)]="user.joinToWork" [disabled]="!isFormEnabled">
            <mat-datepicker-toggle matIconSuffix [for]="hirePicker"></mat-datepicker-toggle>
            <mat-datepicker #hirePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
      <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Representative Address Info</h5>
      </div>
      <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Address Info</h5>
      </div>
      <div  *ngIf="user.role == 'VENDOR'||user.role == 'customer'"  class="form-row">
        <div class="col-12">
          <mat-form-field>
            <mat-label>Address</mat-label>
            <mat-select name="userlocation"
            #userlocation="ngModel"
            [(ngModel)]="user.locationId" [disabled]="!isFormEnabled" (selectionChange)="changeLocation()">
              <mat-option [value]="0" >
                Blank - Client Address
              </mat-option>
              <mat-option [value]="1" >
                Headquarter's Address
              </mat-option>
              <mat-option *ngFor="let loc of companyLocations"
              [value]="loc.id" >
              {{ loc.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
      </div>
      <div class="form-row">
        <div class="col-lg-6">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="address"
            #address="ngModel"
            [(ngModel)]="user.address" [disabled]="!isFormEnabled">
            <mat-label>Address 1</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="address2"
            #address2="ngModel"
            [(ngModel)]="user.address2" [disabled]="!isFormEnabled">
            <mat-label>Address 2</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="country"
            #country="ngModel"
            [(ngModel)]="user.country" [disabled]="!isFormEnabled">
            <mat-label>Country</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="colonia"
            #colonia="ngModel"
            [(ngModel)]="user.colonia" [disabled]="!isFormEnabled">
            <mat-label>State</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="city"
            #city="ngModel"
            [(ngModel)]="user.city" [disabled]="!isFormEnabled">
            <mat-label>City</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput nname="zipCode"
            #zipCode="ngModel"
            [(ngModel)]="user.zipCode" [disabled]="!isFormEnabled">
            <mat-label>Zip Code</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="phone"
            #phone="ngModel"
            [(ngModel)]="user.phone" [disabled]="!isFormEnabled">
            <mat-label>Work Phone</mat-label>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-form-field class="small-form-field">
            <input class="text-dark" type="text" matInput name="mobilePhone"
            #mobilePhone="ngModel"
            [(ngModel)]="user.mobilePhone"[disabled]="!isFormEnabled">
            <mat-label>Mobile Phone</mat-label>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="user.role != 'VENDOR' && user.role != 'customer'" class="form-row">
        <div class="col-lg-12">
          <mat-form-field>
            <mat-label>Default Warehouse Location</mat-label>
            <mat-select 
            name="location"
            #location="ngModel"
            [(ngModel)]="user.location.id" [disabled]="!isFormEnabled">
              <mat-option  *ngFor="let loc of warehouseList"
              [value]="loc.id" >
              {{ loc.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="user.role == 'VENDOR'||user.role == 'customer'" class="form-row">
        <div class="col-lg-12">
        <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Settings</h5>
      </div>
      <div *ngIf="user.role == 'customer'" class="col-lg-6">
  <!--        <select
        id="customerType"
        name="customerType"
        #customerType="ngModel"
        [(ngModel)]="user.customerType"
        placeholder="Customer Type"
        class="form-control fctrl"
        required
      >
        <option value="" disabled>
          * Please select a type
        </option>
        <option value="End User">End User</option>
        <option value="Wholesaler">Wholesaler</option>
        <option value="Broker">Broker</option>
        <option value="Reseller">Reseller</option>
      </select> -->
      <mat-form-field>
        <mat-label>Customer Type</mat-label>
        <mat-select 
        id="customerType"
        name="customerType"
        #customerType="ngModel"
        [(ngModel)]="user.customerType" [disabled]="!isFormEnabled">
        <mat-option value="End User" >
          End User
      </mat-option>
      <mat-option value="Wholesaler">Wholesaler
      </mat-option>
      <mat-option value="Broker">Broker
     
      </mat-option>
      <mat-option value="Reseller">Reseller
     
      </mat-option>
      
        </mat-select>
      </mat-form-field>
      </div>
      <div *ngIf="user.role == 'VENDOR'"  class="col-lg-6">
        <mat-form-field>
          <mat-label>Email Frequency</mat-label>
          <mat-select 
          name="emailFrequency"
          #emailFrequency="ngModel"
          [(ngModel)]="user.emailFrequency" [disabled]="!isFormEnabled">
          <mat-option  *ngFor="let frequency of frequencies"
          [value]="frequency.value" >
          {{ frequency.viewValue }}
          </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      </div>
      <div class="form-row">
        <div class="col-12">
        
            <h5 class="font-weight-bold pt-2 pb-2 pl-1" >Comments</h5>
            <app-comments
            [id_phather]="idUser"
            type_chat="CUSTOMER"
            type_notification="CITA_COMMENT"
          ></app-comments>
          </div>
        
      </div>
      <div class="d-flex justify-content-end fixed-button-container">
        <button  matRipple class="gts-btn-primary-outline mt-2 mb-2 mr-2 btn-save" (click)="goBack()"  >
          <span class="gts-btn-text">Cancel</span>
        </button>
        <button  matRipple class="gts-btn-primary mt-2 mb-2 btn-cancel" (click)="onSubmit();"  >
          <span class="gts-btn-text">Save Changes</span>
         </button>
  
      </div>
      </form>
    </div>
  

    
    <!-- rank customer end  -->
  </div>
  </div>
<!-- END MOBILE VIEW -->
 <!-- Customer show end-->
  </div>
  
</div>
</div>
</div>
</div>
<!-- <div *ngIf="user.role == 'customer'" class="">
  <div class="form-row">
    <h4>Rank</h4>
  </div>
</div> -->
<!-- AQUI COMIENZA EL CODIGO ANTERIOR -->
<!--           <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>

           <h4 *ngIf="user.role == 'customer'" class="card-title">
              Client's Information
            </h4>
            <h4 *ngIf="user.role == 'VENDOR'" class="card-title">
              Vendor's Information
            </h4>
            <h4
              *ngIf="user.role != 'VENDOR' && user.role != 'customer'"
              class="card-title"
            >
              Rep's Information
            </h4> 
          </div> -->

         <!--  <div class="card-body">

            <div class="tab-content tab-space">

              
        
              <div class="tab-pane active" id="link1">
                <form #userForm="ngForm" (ngSubmit)="onSubmit()">
                  <div
                    *ngIf="user.role != 'VENDOR' && user.role != 'customer'"
                    class="row bloque mi"
                  >
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating"
                          >Department and Permissions</label
                        >
                        <select
                          name="profile"
                          #profile="ngModel"
                          [(ngModel)]="user.role"
                          class="form-control fctrl"
                        >
                          <option
                            *ngFor="let item of groupsList"
                            value="{{ item.id }}"
                          >
                            {{ item.name | titlecase }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating"
                          >Select department to keep track of KPIs</label
                        >
                        <select
                          name="deptoToCount"
                          #deptoToCount="ngModel"
                          [(ngModel)]="user.deptoToCount"
                          class="form-control fctrl"
                        >
                          <option
                            *ngFor="let depto of deptos"
                            value="{{ depto.value }}"
                          >
                            {{ depto.viewValue | titlecase }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating"
                          >Enable as a Driver</label
                        >
                        <select
                          name="enabledriver"
                          #enabledriver="ngModel"
                          [(ngModel)]="this.user.enableAsDriver"
                          class="form-control fctrl"
                        >
                          <option [value]="1">Yes</option>
                          <option [value]="0">No</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row bloque mi">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="form-group"
                            *ngIf="
                              user.role == 'VENDOR' || user.role == 'customer'
                            "
                          >
                            <label class="bmd-label-floating"
                              >Company Name</label
                            >
                            <span class="bmd-form-group">
                              <div class="input-group">
                                <select
                                  id="companyName"
                                  name="companyLinked"
                                  #companyLinked="ngModel"
                                  [(ngModel)]="companySelected"
                                  (change)="changeCompany()"
                                  class="form-control fctrl"
                                  [disabled]="!editCompany"
                                >
                                  <option
                                    *ngFor="let company of companies"
                                    [value]="company.id"
                                  >
                                    {{ company.name }}
                                  </option>
                                </select>
                                <div
                                  class="input-group-prepend"
                                  *ngIf="!editCompany"
                                >
                                  <span class="input-group-text">
                                    <button
                                      class="btn btn-primary btn-sm"
                                      (click)="changeCompanyName()"
                                    >
                                      <i
                                        class="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>

                          <div
                            class="form-group"
                            *ngIf="
                              user.role != 'VENDOR' && user.role != 'customer'
                            "
                          >
                            <label class="bmd-label-floating">Company</label>
                            <input
                              type="text"
                              disabled=""
                              class="form-control fctrl"
                              name="company"
                              [(ngModel)]="user.companyLinked.name"
                              placeholder=""
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">Title</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="ocupation"
                              #ocupation="ngModel"
                              [(ngModel)]="user.ocupation"
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">First Name</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="name"
                              #name="ngModel"
                              [(ngModel)]="user.name"
                              required
                            />
                            <span *ngIf="!name.valid && name.touched"
                              >¡Name not valid!</span
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">Last Name</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="surname"
                              #surname="ngModel"
                              [(ngModel)]="user.surname"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="bmd-label-floating">email</label>
                            <input
                              type="email"
                              class="form-control fctrl"
                              name="email"
                              #email="ngModel"
                              [(ngModel)]="user.email"
                              [readonly]="identity.role !== 'ADMINISTRATOR'"
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="bmd-label-floating">Gender</label>
                            <select
                              name="gender"
                              #gender="ngModel"
                              [(ngModel)]="user.gender"
                              class="form-control fctrl"
                            >
                              <option
                                *ngFor="let tipo of sexos"
                                [value]="tipo.value"
                              >
                                {{ tipo.viewValue }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div
                          *ngIf="
                            user.role != 'customer' && user.role != 'VENDOR'
                          "
                          class="col-md-3"
                        >
                          <div class="form-group">
                            <label class="bmd-label-floating">Hire Date</label>
                            <input
                              type="date"
                              class="form-control fctrl"
                              name="starToWorkDate"
                              #starToWorkDate="ngModel"
                              [(ngModel)]="user.joinToWork"
                              [readonly]="identity.role !== 'ADMINISTRATOR'"
                            />
                          </div>
                        </div>
                        <div
                          *ngIf="
                            user.role != 'customer' && user.role != 'VENDOR'
                          "
                          class="col-md-3"
                        >
                          <div class="form-group">
                            <label class="bmd-label-floating">Birth Date</label>
                            <input
                              type="date"
                              class="form-control fctrl"
                              name="birthDate"
                              #birthDate="ngModel"
                              [(ngModel)]="user.birthDate"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div
                            *ngIf="
                              user.role === 'customer' || user.role === 'VENDOR'
                            "
                            class="col-md-3"
                          >
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                >Date</label
                              >
                              <input
                                type="text"
                                class="form-control fctrl"
                                name="createdAt"
                                #createdAt="ngModel"
                                [(ngModel)]="user.created_at"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="welcomeSent == 0" class="alert alert-warning">
                    This user didn't receive the welcome email, because it was
                    imported from IQ.
                    <button (click)="sendWelcomeEmail()" class="btn btn-info">
                      Send welcome email
                    </button>
                  </div>

                  <div class="row bloque mi">
                    <div class="col-md-12">
                      <h3 class="card-title title">
                        <b>Address information:</b>
                      </h3>
                      <hr />

                      <div class="row">
                        <div
                          *ngIf="
                            user.role == 'VENDOR' || user.role == 'customer'
                          "
                          class="col-md-6"
                        >
                          <div class="form-group">
                            <label class="bmd-label-floating">Address </label>
                            <select
                              style="cursor: pointer"
                              name="userlocation"
                              #userlocation="ngModel"
                              [(ngModel)]="user.locationId"
                              (change)="changeLocation()"
                              class="form-control fctrl"
                            >
                              <option [value]="0">
                                Blank - Client Address
                              </option>
                              <option [value]="null">
                                Headquarter's Address
                              </option>
                              <option
                                *ngFor="let loc of companyLocations"
                                [value]="loc.id"
                              >
                                {{ loc.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Address Line #</label
                            >
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="address"
                              #address="ngModel"
                              [(ngModel)]="user.address"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Address Line 2 #</label
                            >
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="address2"
                              #address2="ngModel"
                              [(ngModel)]="user.address2"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">City</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="city"
                              #city="ngModel"
                              [(ngModel)]="user.city"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">State</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="colonia"
                              #colonia="ngModel"
                              [(ngModel)]="user.colonia"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="bmd-label-floating">Country</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="country"
                              #country="ngModel"
                              [(ngModel)]="user.country"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label class="bmd-label-floating">Zip Code</label>
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="zipCode"
                              #zipCode="ngModel"
                              [(ngModel)]="user.zipCode"
                              [disabled]="user.locationId != 0"
                            />
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-group">
                            <label
                              style="margin-bottom: 15px"
                              class="bmd-label-floating"
                              >Work Phone</label
                            >
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="phone"
                              #phone="ngModel"
                              [(ngModel)]="user.phone"
                            />
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-group">
                            <label
                              style="margin-bottom: 15px"
                              class="bmd-label-floating"
                              >Mobile Phone</label
                            >
                            <input
                              type="text"
                              class="form-control fctrl"
                              name="mobilePhone"
                              #mobilePhone="ngModel"
                              [(ngModel)]="user.mobilePhone"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="user.role != 'VENDOR' && user.role != 'customer'"
                    class="row bloque mi"
                  >
                    <div class="col-md-12">
                      <h3 class="card-title title"><b>Settings:</b></h3>
                      <hr />

                      <div class="row">
                        <div
                          *ngIf="
                            user.role != 'VENDOR' && user.role != 'customer'
                          "
                          class="col-md-6"
                        >
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Default Warehouse Location</label
                            >
                            <select
                              name="location"
                              #location="ngModel"
                              [(ngModel)]="user.location.id"
                              class="form-control fctrl"
                            >
                              <option
                                *ngFor="let loc of warehouseList"
                                [value]="loc.id"
                              >
                                {{ loc.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row bloque mi">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6" *ngIf="user.role == 'VENDOR'">
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Email Frequency</label
                            >
                            <select
                              name="emailFrequency"
                              #emailFrequency="ngModel"
                              [(ngModel)]="user.emailFrequency"
                              class="form-control fctrl"
                            >
                              <option
                                *ngFor="let frequency of frequencies"
                                [value]="frequency.value"
                              >
                                {{ frequency.viewValue }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6" *ngIf="user.role == 'customer'">
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Customer Type:</label
                            >
                            <select
                              id="customerType"
                              name="customerType"
                              #customerType="ngModel"
                              [(ngModel)]="user.customerType"
                              placeholder="Customer Type"
                              class="form-control fctrl"
                              required
                            >
                              <option value="" disabled>
                                * Please select a type
                              </option>
                              <option value="End User">End User</option>
                              <option value="Wholesaler">Wholesaler</option>
                              <option value="Broker">Broker</option>
                              <option value="Reseller">Reseller</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="false" class="row bloque mi">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="bmd-label-floating"
                              >Default Warehouse Location</label
                            >
                            <select
                              name="location"
                              #location="ngModel"
                              [(ngModel)]="locationSelected"
                              class="form-control fctrl"
                            >
                              <option
                                *ngFor="let location of locations"
                                [value]="location.id"
                              >
                                {{ location.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                         <div class="col-md-6">

                            <div class="form-group" *ngIf="user.role == 'VENDOR' || user.role == 'customer'">
                              <label class="bmd-label-floating">Default Term</label>
                              <select name="term" #term="ngModel" [(ngModel)]="termSelected" class="form-control fctrl">
                                <option *ngFor="let term of terms" [value]="term.id">
                                  {{ term.name }}
                                </option>
                              </select>
                            </div>

                          </div> 
                      </div>

                      <div class="row">
                          <div class="col-md-6">

                            <div class="form-group" *ngIf="user.role == 'VENDOR' || user.role == 'customer'">
                              <label class="bmd-label-floating">Default Condition</label>
                              <select name="condition" #condition="ngModel" [(ngModel)]="conditionSelected"
                                class="form-control fctrl">
                                <option *ngFor="let condition of conditions" [value]="condition.id">
                                  {{ condition.name }}
                                </option>
                              </select>
                            </div>

                          </div>
                          <div class="col-md-6">

                            <div class="form-group" *ngIf="user.role == 'VENDOR' || user.role == 'customer'">
                              <label class="bmd-label-floating">Default Currency</label>
                              <select name="currency" #currency="ngModel" [(ngModel)]="currencySelected"
                                class="form-control fctrl">
                                <option *ngFor="let currency of currencies" [value]="currency.id">
                                  {{ currency.name }}
                                </option>
                              </select>
                            </div>

                          </div>
                        </div> 
                    </div>
                  </div>
                  <br />
                  <h4>Notes:</h4>
                  <app-comments
                    [id_phather]="idUser"
                    type_chat="CUSTOMER"
                    type_notification="CITA_COMMENT"
                  ></app-comments>
                  <div
                    class="alert alert-success"
                    *ngIf="status_user == 'success'"
                  >
                    Changes have been saved!
                  </div>

                  <div
                    class="alert alert-danger"
                    *ngIf="status_user == 'error'"
                  >
                    Changes have not been saved!
                  </div>

                  <div class="row mt-4">
                    <div style="display: -webkit-inline-box" class="col-md-12">
                      <div
                        *ngIf="
                          this.identity.role == 'ADMINISTRATOR' ||
                          identity.sub == user.id ||
                          identity.role == 'PURCHASINGREP' ||
                          identity.role == 'CLERICALREP' ||
                          identity.role == 'SALESREP' ||
                          identity.role == 'MANAGER'
                        "
                        mat-dialog-actions
                      >
                        <button
                          mat-raised-button
                          type="submit"
                          class="btn btn-sm btn- btn-rose"
                        >
                          Save Changes
                        </button>
                      </div>
                      <button
                        style="margin-left: 20px"
                        class="btn btn-sm btn-info"
                        (click)="goBack()"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> -->
<!--  -->
          <!-- <div class="card-body">
            <form>
              <div class="clearfix"></div>
            </form>
          </div> -->
        

        <!--   <div class="row">
            <div
              *ngIf="user.role == 'VENDOR' || user.role == 'customer'"
              class="col-md-12"
            >
              <div class="card">
                <div class="card-header card-header-rose card-header-icon">
                  <div class="card-icon">
                    <i class="material-icons">assignment</i>
                  </div>
                  <h4 class="card-title">Contact History</h4>
                </div>
                <div class="card-body">
                  <div class="toolbar">
          
                  </div>
                  <div class="material-datatables">
                    <table
                      id="datatables1"
                      class="table table-striped table-no-bordered table-hover"
                      cellspacing="0"
                      width="100%"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>{{ tableContacts.headerRow[0] }}</th>
  
                          <th class="text-center">
                            {{ tableContacts.headerRow[1] }}
                          </th>
                          <th class="text-center">
                            {{ tableContacts.headerRow[2] }}
                          </th>
                          <th class="text-center">
                            {{ tableContacts.headerRow[3] }}
                          </th>
                          <th class="text-center">
                            {{ tableContacts.headerRow[4] }}
                          </th>
  
                          <th class="disabled-sorting text-right">
                            {{ tableContacts.headerRow[5] }}
                          </th>
                        </tr>
                      </thead>
  
                      <tbody>
                        <tr
                          id="contacthistoryregistry{{ row[0] }}"
                          *ngFor="let row of tableContacts.dataRows"
                        >
                          <td>{{ row[0] }}</td>
  
                          <td class="text-center">{{ row[1] }}</td>
                          <td class="text-center">
                            {{ row[2] * 1000 | date : "MM-dd-yyyy" }}
                          </td>
                          <td class="text-center">
                            {{ row[3] * 1000 | date : "MM-dd-yyyy" }}
                          </td>
                          <td class="text-center">{{ row[4] }}</td>
  
                          <td class="text-right">
                            <a
                              href="#"
                              class="btn btn-link btn-warning btn-just-icon edit"
                              ><i class="material-icons">dvr</i></a
                            >
                            <a
                              (click)="deleteFolderfirst(row[0])"
                              class="btn btn-link btn-danger btn-just-icon"
                              ><i class="material-icons">close</i></a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <input
                      type="hidden"
                      name="borrarUser"
                      value=""
                      id="borrarUser"
                      (click)="deleteUser()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> -->
  
          <!--<div class="row">
            <div class="col-md-6">
  
              <app-net-terms [user_id]="idUser" [companyLinked]="companySelected"></app-net-terms>
  
            </div>
          </div>-->
       <!--  -->
      <!--   <div class="col-md-4">
          <div class="card">
            <div class="card-body" *ngIf="user.role == 'customer'">
              <div class="row">
                <div class="col-md-12">
                  <button
                    (click)="openDialog()"
                    mat-raised-button
                    class="btn btn-success button-profile"
                    style="width: 90%"
                  >
                    <span class="btn-label">
                      <i class="material-icons">note_add</i>
                    </span>
                    Create Contact History
                  </button>
                  <button
                    *ngIf="
                      (this.privilegio.level === 'ADMINISTRATOR' ||
                        this.privilegio.level === 'MANAGER' ||
                        this.privilegio.level === 'SALESREP') &&
                      (user.role == 'VENDOR' || user.role == 'customer')
                    "
                    (click)="openChangeRep()"
                    mat-raised-button
                    class="btn btn-success button-profile"
                    style="width: 90%"
                  >
                    <span class="btn-label">
                      <i class="material-icons">compare_arrows</i>
                    </span>
                    Change Rep
                  </button>
                </div>
              </div>
              <div class="row bloque-simple mi">
                <div class="col-md-12">
                  <h3 style="text-align: center" class="card-title title">
                    <b>Rank:</b>
                  </h3>
  
                  <div class="row">
                    <div class="col-md-6">
                      <label>Pricing: </label> <br />
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPricing = 1"
                          [ngClass]="{
                            'fa-star': user.customerPricing >= 1,
                            'fa-star-o': user.customerPricing < 1
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPricing = 2"
                          [ngClass]="{
                            'fa-star': user.customerPricing >= 2,
                            'fa-star-o': user.customerPricing < 2
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPricing = 3"
                          [ngClass]="{
                            'fa-star': user.customerPricing >= 3,
                            'fa-star-o': user.customerPricing < 3
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPricing = 4"
                          [ngClass]="{
                            'fa-star': user.customerPricing >= 4,
                            'fa-star-o': user.customerPricing < 4
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPricing = 5"
                          [ngClass]="{
                            'fa-star': user.customerPricing >= 5,
                            'fa-star-o': user.customerPricing < 5
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                    <div class="col-md-6">
                      <label>Response Time: </label> <br />
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerResponseTime = 1"
                          [ngClass]="{
                            'fa-star': user.customerResponseTime >= 1,
                            'fa-star-o': user.customerResponseTime < 1
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerResponseTime = 2"
                          [ngClass]="{
                            'fa-star': user.customerResponseTime >= 2,
                            'fa-star-o': user.customerResponseTime < 2
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerResponseTime = 3"
                          [ngClass]="{
                            'fa-star': user.customerResponseTime >= 3,
                            'fa-star-o': user.customerResponseTime < 3
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerResponseTime = 4"
                          [ngClass]="{
                            'fa-star': user.customerResponseTime >= 4,
                            'fa-star-o': user.customerResponseTime < 4
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerResponseTime = 5"
                          [ngClass]="{
                            'fa-star': user.customerResponseTime >= 5,
                            'fa-star-o': user.customerResponseTime < 5
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                    <div class="col-md-6">
                      <label>Payment on Time: </label> <br />
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPaymentOnTime = 1"
                          [ngClass]="{
                            'fa-star': user.customerPaymentOnTime >= 1,
                            'fa-star-o': user.customerPaymentOnTime < 1
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPaymentOnTime = 2"
                          [ngClass]="{
                            'fa-star': user.customerPaymentOnTime >= 2,
                            'fa-star-o': user.customerPaymentOnTime < 2
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPaymentOnTime = 3"
                          [ngClass]="{
                            'fa-star': user.customerPaymentOnTime >= 3,
                            'fa-star-o': user.customerPaymentOnTime < 3
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPaymentOnTime = 4"
                          [ngClass]="{
                            'fa-star': user.customerPaymentOnTime >= 4,
                            'fa-star-o': user.customerPaymentOnTime < 4
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerPaymentOnTime = 5"
                          [ngClass]="{
                            'fa-star': user.customerPaymentOnTime >= 5,
                            'fa-star-o': user.customerPaymentOnTime < 5
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                    <div class="col-md-6">
                      <label>Easy to work with: </label> <br />
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerEasyToWorkWith = 1"
                          [ngClass]="{
                            'fa-star': user.customerEasyToWorkWith >= 1,
                            'fa-star-o': user.customerEasyToWorkWith < 1
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerEasyToWorkWith = 2"
                          [ngClass]="{
                            'fa-star': user.customerEasyToWorkWith >= 2,
                            'fa-star-o': user.customerEasyToWorkWith < 2
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerEasyToWorkWith = 3"
                          [ngClass]="{
                            'fa-star': user.customerEasyToWorkWith >= 3,
                            'fa-star-o': user.customerEasyToWorkWith < 3
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerEasyToWorkWith = 4"
                          [ngClass]="{
                            'fa-star': user.customerEasyToWorkWith >= 4,
                            'fa-star-o': user.customerEasyToWorkWith < 4
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a class="rank btn-just-icon">
                        <i
                          class="fa"
                          (click)="user.customerEasyToWorkWith = 5"
                          [ngClass]="{
                            'fa-star': user.customerEasyToWorkWith >= 5,
                            'fa-star-o': user.customerEasyToWorkWith < 5
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="card-body" *ngIf="user.role != 'customer'">
              <h6 class="card-category text-gray">Profile</h6>
              <h4 class="card-title">{{ user.name }} {{ user.surname }}</h4>
              <p class="card-description">
                <button
                  *ngIf="this.privilegio != 'VENDOR'"
                  [routerLink]="['/pages/userchangepassword', user.id]"
                  mat-raised-button
                  class="btn btn-warning button-profile"
                  style="width: 90%"
                >
                  <span class="btn-label">
                    <i class="material-icons">note_add</i>
                  </span>
                  Change Password
                </button>
                <button
                  *ngIf="
                    this.privilegio.level != 'VENDOR' && user.role == 'VENDOR'
                  "
                  (click)="openDialog()"
                  mat-raised-button
                  class="btn btn-success button-profile"
                  style="width: 90%"
                >
                  <span class="btn-label">
                    <i class="material-icons">note_add</i>
                  </span>
                  Create Contact History
                </button>
                <button
                  *ngIf="user.role != 'customer' && user.role != 'VENDOR'"
                  (click)="openDelegate()"
                  mat-raised-button
                  class="btn btn-success button-profile"
                  style="width: 90%"
                >
                  <span class="btn-label">
                    <i class="material-icons">compare_arrows</i>
                  </span>
                  Delegate Clients
                </button>
                <button
                  *ngIf="
                    (this.privilegio.level === 'ADMINISTRATOR' ||
                      this.privilegio.level === 'MANAGER' ||
                      this.privilegio.level === 'SALESREP') &&
                    (user.role == 'VENDOR' || user.role == 'customer')
                  "
                  (click)="openChangeRep()"
                  mat-raised-button
                  class="btn btn-success button-profile"
                  style="width: 90%"
                >
                  <span class="btn-label">
                    <i class="material-icons">compare_arrows</i>
                  </span>
                  Change Rep
                </button>
                <button
                  *ngIf="
                    user.role != 'customer' &&
                    user.role != 'VENDOR' &&
                    idUser == identity.sub
                  "
                  mat-raised-button
                  class="btn btn-success button-profile"
                  style="width: 90%"
                  (click)="openFormModal()"
                >
                  Holiday Form
                </button>
                <button
                  *ngIf="user.role === 'VENDOR'"
                  mat-raised-button
                  [ngClass]="user.activo === 0 ? 'btn btn-success button-profile' : 'btn btn-danger button-profile'"        
                  style="width: 90%"
                  (click)="activeVendor(user.id, user.activo)"
                >
                  <span class="btn-label">
                    <i class="material-icons">compare_arrows</i>
                  </span>
                  CHANGE {{user.activo === 0 ? 'ACTIVE' : 'INACTIVE'}}                
                </button>
                <button
                  *ngIf="this.identity.role == 'ADMINISTRATOR'"
                  (click)="openModalResetMFA()"
                  mat-raised-button
                  class="btn btn-danger button-profile"
                  style="width: 90%"
                >
                  <span class="btn-label">
                    <i class="material-icons">compare_arrows</i>
                  </span>
                  Reset MFA
                </button>
              </p>
            </div>
             <div class="card-body" *ngIf="user.role == 'customer'">
              <h3>Tags</h3>
              <ul style="text-align: left;">
                <li *ngFor="let item of usersTags">{{item.name}}</li>
              </ul>
            </div> 
          </div>
  
          <div class="card card-profile" *ngIf="user.role == 'VENDOR'">
            <div class="card-body">
              <h6 class="card-category text-gray">Purchasing Rep</h6>
              <h4 class="card-title">
                <a [routerLink]="['/pages/user', user.managedBy]"
                  ><i class="material-icons">person</i>
                  {{ user.managedByString }}</a
                >
              </h4>
              <p class="card-description"></p>
            </div>
          </div>
  
          <div class="card card-profile" *ngIf="user.role == 'customer'">
            <div class="card-body">
              <div class="row bloque-simple mi">
                <div class="col-md-12">
                  <h3 style="text-align: center" class="card-title title">
                    <b>Categories:</b>
                  </h3>
  
                  <div class="row">
                    <div class="col-12" *ngFor="let item of categories">
                      <div class="row">
                        <mat-checkbox
                          [name]="item.name"
                          (change)="addCategoire(item, $event)"
                          [checked]="isCheked(item)"
                          >{{ item.name }}</mat-checkbox
                        >
                      </div>
                      <div *ngIf="isAdded(item.id)">
                        <div class="row" *ngIf="item.sub.length > 1">
                          &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                          <mat-checkbox
                            [name]="item.id"
                            (change)="
                              addCategoire(
                                { id: item.id, father: item.id, name: 'All' },
                                $event
                              )
                            "
                            [checked]="checkedAll(item.id)"
                            >All</mat-checkbox
                          >
                        </div>
                        <div class="row" *ngFor="let i of item.sub">
                          &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                          <mat-checkbox
                            [name]="i.name"
                            (change)="addCategoire(i, $event)"
                            [checked]="isCheked(i)"
                          >
                            {{ i.name }}</mat-checkbox
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
     
  
      <!-- <div class="row" *ngIf="user.role != 'customer' && user.role != 'VENDOR'">
        <div class="col-md-8">
          <div class="card">
  
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon">
                <i class="material-icons">perm_identity</i>
              </div>
              <h4 class="card-title">
                Holidays and Absences
              </h4>
            </div>
  
            <div class="card-body">
  
              <div class="row">
                <div class="col-12">
                  <div *ngIf="loadingHd" style="text-align: center">
                    <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                  </div>
    
                  <app-holydays-table *ngIf="!loadingHd" [elements]="holydasy" (out)="boton($event)" [actions]='false'></app-holydays-table>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div> -->
<!-- Aqui termina el codigo anterior  -->
<div
  class="modal fade"
  id="hdModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="text-align: center">
        <div>
          <h2>
            <b>Holidays</b>
          </h2>
          <br />
        </div>
      </div>

      <div
        *ngIf="guardando || cargando"
        style="text-align: center"
        class="modal-body"
      >
        <app-loading *ngIf="cargando"></app-loading>
        <div *ngIf="guardando">
          <h2>
            <b><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> Saving...</b>
          </h2>
        </div>
      </div>

      <div *ngIf="!guardando && !cargando">
        <div class="modal-body">
          <form #f="ngForm">
            <div *ngIf="action != 'delete'" class="input-group">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Start Date: </label>
                    <input
                      type="date"
                      class="form-control"
                      name="start"
                      #s="ngModel"
                      [(ngModel)]="hdStart"
                      (change)="disponible()"
                      required
                      [disabled]="action == 'read'"
                      matInput
                    />
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group">
                    <label>End Date: </label>
                    <input
                      type="date"
                      class="form-control"
                      name="end"
                      #end="ngModel"
                      [(ngModel)]="hdEnd"
                      (change)="disponible()"
                      required
                      [disabled]="action == 'read'"
                      matInput
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="bmd-label-floating">Notes:</label>
                    <div class="form-group">
                      <textarea
                        name="trakingNotes"
                        #trakingNotes="ngModel"
                        [(ngModel)]="hdComments"
                        class="form-control"
                        rows="3"
                        [disabled]="action == 'read'"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div
                *ngIf="!hdAvailability"
                class="alert alert-danger"
                role="alert"
              >
                Date range is not available!
              </div>
            </div>

            <div *ngIf="action == 'delete'">
              <h6>
                <b
                  ><i
                    class="fa fa-exclamation-triangle"
                    style="color: 'red'"
                    aria-hidden="true"
                  ></i>
                  Are you sure you want to delete this Holydas?
                </b>
              </h6>
            </div>
          </form>
        </div>

        <div class="modal-footer" style="text-align: center">
          <button
            type="button"
            class="btn btn-danger btn-lg btn-block"
            (click)="endHD()"
          >
            {{ action == "read" ? "Close" : "Cancel" }}
          </button>
          &nbsp;&nbsp;
          <button
            *ngIf="action != 'read'"
            type="button"
            class="btn btn-primary btn-lg btn-block"
            (click)="saveHD()"
            [disabled]="!valid(f)"
          >
            {{ action == "delete" ? "Continue" : "Save" }}
          </button>
          <button
            *ngIf="action == 'read'"
            type="button"
            class="btn btn-warning btn-lg btn-block"
            (click)="action = 'update'"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="hdFormModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="text-align: center">
        <div>
          <h2>
            <b>Holidays Form</b>
          </h2>
          <br />
        </div>
      </div>

      <div class="modal-body">
        <form #hdForm="ngForm">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Time Off Start Date: </label>
                <input
                  type="date"
                  class="form-control"
                  name="start"
                  #s="ngModel"
                  (change)="disponible()"
                  [(ngModel)]="holydays.timeOffStartDate"
                  required
                  matInput
                />
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Time:</label>
                <input
                  type="time"
                  class="form-control"
                  name="startTime"
                  (change)="disponible()"
                  [(ngModel)]="holydays.hrTimeOffStartDate"
                  required
                />
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Return To Work Date: </label>
                <input
                  type="date"
                  class="form-control"
                  name="end"
                  #end="ngModel"
                  (change)="disponible()"
                  [(ngModel)]="holydays.returnToWorkDate"
                  [disabled]="action == 'read'"
                  required
                  matInput
                />
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Time:</label>
                <input
                  type="time"
                  class="form-control"
                  name="ebdTime"
                  (change)="disponible()"
                  [(ngModel)]="holydays.hrReturnToWorkDate"
                  required
                />
              </div>
            </div>
          </div>

          <div
            class="row"
            *ngIf="
              holydays.timeOffStartDate > holydays.returnToWorkDate &&
              holydays.returnToWorkDate != ''
            "
          >
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                Return To Work Date can’t be before the Time Off Start Date,
                please select another time
              </div>
            </div>
          </div>

          <div
            class="row"
            *ngIf="
              holydays.timeOffStartDate === holydays.returnToWorkDate &&
              holydays.hrTimeOffStartDate > holydays.hrReturnToWorkDate
            "
          >
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                Return To Work Date can’t be before the Time Off Start Date,
                please select another time
              </div>
            </div>
          </div>

          <div class="row" *ngIf="statusHolyday != null">
            <div class="col-12">
              <div
                class="alert alert-danger"
                role="alert"
                *ngIf="
                  statusHolyday.status == 'unavailable' &&
                  holydays.timeOffStartDate <= holydays.returnToWorkDate
                "
              >
                Sorry! You cannot authorize free days within the selected date
                range, you may have pending activities, please check your
                activities or choose a different date range.
              </div>
              <div
                class="alert alert-success"
                role="alert"
                *ngIf="
                  statusHolyday.status == 'success' &&
                  holydays.timeOffStartDate <= holydays.returnToWorkDate
                "
              >
                Available! {{ statusHolyday.msg }}
              </div>
            </div>
          </div>

          <br />

          <div class="row" style="text-align: center">
            <div class="col-12">
              <div class="form-group">
                <mat-radio-group
                  name="typeOfLeave"
                  [(ngModel)]="holydays.typeOfLeave"
                  aria-label="Select an option"
                  required
                >
                  <mat-radio-button value="PTO"
                    >PTO (With Pay)</mat-radio-button
                  >
                  &nbsp;&nbsp;
                  <mat-radio-button value="Other"
                    >Other Without Pay - describe in
                    <strong>Reason For Leave box</strong>.
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <mat-form-field class="example-full-width has-label">
                  <input
                    type="text"
                    name="reasonforLeave"
                    [(ngModel)]="holydays.reasonforLeave"
                    matInput
                    id="text"
                    placeholder="Reason for Leave"
                    [disabled]="action == 'read'"
                    required
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-danger" (click)="closeFormModal()">Close</button>
        &nbsp;&nbsp;
        <button
          class="btn btn-primary"
          [disabled]="!validhd(hdForm)"
          (click)="saveHd()"
        >
          <i
            *ngIf="savingHd"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalMFA" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" id="modal-title">Reset MFA</h4>
          </div>
          <div class="modal-body">
            <p>
              <strong>Are you sure you want to reset the MFA for this user?</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="saveMFA()">Yes</button>
            &nbsp;
            <button type="button" class="btn btn-danger" data-dismiss="modal">No</button>
          </div>

        </div>
    </div>
</div>